
import _ from 'lodash'
import React from 'react'
import Slider from 'react-slick'
import ScheduleItem from './scheduleItem'

import {BackArrowIcon} from '~/assets/svg';
import 'slick-carousel/slick/slick.css'
import './slick-theme.css'
import './style.scss'

class ConceptCarousel extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      items: _.get(props, 'data.contentData', []),
      currentItem: 0,
      isMobile: window.innerWidth <= 1025
    }   
  }

  shouldComponentUpdate(nextProps, nextState){
  	if(this.state.currentItem === nextState.currentItem && this.state.isMobile === nextState.isMobile){
  		return false
  	}
  	return true
  }

  componentDidMount() {
    this.setState({
      innerWidth: window.innerWidth
    });
    window.addEventListener('resize', () => { this.setState({ isMobile: window.innerWidth <= 1025 }) }, false)
  }

  componentWillMount(){
    clearInterval(this.interval)
  }

  goBack() {
    window.history.back();
  }


  render() {
    const hasMultipleItems = this.state.items && this.state.items.length > 1;
    const timeDelay = (_.get(this.props.layout, 'settings.timeDelay', 4) * 1000); 
    if(this.state.items.length === 0){
      return <div></div>
    }

    return <div className="concept-carousel">
     <div className="module-header">
      <div className="left">
        <a onClick={this.goBack} className="back-arrow"><BackArrowIcon/></a>
      </div>
      CONCEPTS
      </div>
      <div className="module-header">NEW THIS WEEK!</div>
      <div className="schedule-carousel-container">
          <div className={`carousel ` + (_.get(this.props, "layout.settings.isHidden") ? "hide" : "")}>
            {this.state.items && this.state.items.length > 0 &&
                <Slider
                  variableWidth={!this.state.isMobile && true}
                  ref={Slider => (this.Slider = Slider)}
                  infinite={true}
                  speed={750}
                  autoplay={hasMultipleItems}
                  autoplaySpeed={timeDelay}
                  dots={hasMultipleItems}>
                  {this.state.items.map((item, i) => <div key={i}>
                      <ScheduleItem item={item} maxWidth={this.state.innerWidth} />
                    </div>)
                  }
                </Slider>
            }
          </div>
        </div>
      </div>
  }
}

export default ConceptCarousel;

